import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {connect} from "react-redux";
import {caseAlertMarkRead} from "actions/CaseAlerts";

export const RETURN_FROM_MANAGER = "RETURN_FROM_MANAGER";
export const RETURN_FROM_FIELD = "RETURN_FROM_FIELD";

const mapActionToIcon = (action) => {
    switch(action) {
        case "Returned by Manager":
        case "Returned from Field":
            return "message";
    }
};

const getReadStatusClassName = (isNew) => {
    if(isNew)
        return " unread";
    return " read";
};

const renderCaseReturn = (notification) => {
    const {controlNumber, customerNumber, customerName, message} = notification;
    return (
        <React.Fragment>
            <div>
                <div className="controlnumber">{controlNumber}</div>
                <div>{`: ${customerNumber} ${customerName}`}</div>
            </div>
            <div className="message">{message}</div>
        </React.Fragment>
    );
};

const renderEmptyListItem = () => {
    return (
        <div>{"No Case Alerts"}</div>
    );
};

const renderMetaData = (action, timeStamp) => {
    return (
        <div>
            <i title={action} className="md-icon material-icons">{mapActionToIcon(action)}</i>
            <div className="metadata">{` ${action} ${timeStamp}`}</div>
        </div>
    );
};

const mapActionToRenderMethod = (action) => {
    switch(action) {
        case RETURN_FROM_MANAGER:
        case RETURN_FROM_FIELD:
        default:
            return renderCaseReturn;
    }
};

const MenuItem = ({className, caseAlertMarkRead, notification, emptyListItem}) => {
    const {isNew, id, action, timeStamp} = notification;
    return (
        <div className={className + getReadStatusClassName(isNew)} onClick={() => caseAlertMarkRead(id)}>
            {emptyListItem ? (
                renderEmptyListItem()
            ) : (
                <React.Fragment>
                    {mapActionToRenderMethod(action)(notification)}
                    {renderMetaData(action, timeStamp)}
                </React.Fragment>
            )}
        </div>
    );
};

MenuItem.defaultProps = {
    notification: {},
    emptyListItem: false,
};

MenuItem.propTypes = {
    //Pure Props
    notification: PropTypes.object,
    emptyListItem: PropTypes.bool,

    //Action
    caseAlertMarkRead: PropTypes.func,

    //Styled Components Prop
    className: PropTypes.string,
};

const StyledMenuItem = styled(MenuItem)`
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    padding: var(--padding-10px);
    & > div {
        display: flex;
    }
    .controlnumber {
        font-weight: 500;
    }
    .message {
        padding-left: var(--padding-10px);
    }
    &.unread {
        background-color: #c8102e1A;
    }
    &.read {}
    .metadata {
        font-size: 12px;
        line-height: 1.5;
    }
`;

const mapDispatchToProps = (dispatch) => ({
    caseAlertMarkRead(id) {
        dispatch(caseAlertMarkRead(id));
    }
});

export default connect(null, mapDispatchToProps)(StyledMenuItem);